import Box from "@mui/material/Box";
import BreadCrumb from "app/components/BreadCrumb";
import { ScrollableView } from "app/components/ScrollableView";
import React, { useEffect } from "react";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import { useInjectReducer, useInjectSaga } from "utils/redux-injectors";

import ActionBar from "./ActionBar";
import AddFrontClearanceModal from "./AddFrontClearanceModal";
import FrontCleranceTable from "./FrontCleranceTable";
import {
  selectFilteredFrontClearanceList,
  selectFrontClearanceLoading,
  selectFrontClearanceMeta,
} from "./redux/selector";
import frontClearanceSaga from "./redux/saga";
import { frontClearanceActions, reducer, sliceKey } from "./redux/slice";
import { useStyles } from "./styles";
import { FrontClearanceFilterEnum } from "./types";

const FrontClearance = () => {
  const { t, i18n } = useTranslation();
  const styles = useStyles();
  const dispatch = useDispatch();

  useInjectReducer({
    key: sliceKey,
    reducer,
  });

  useInjectSaga({
    key: sliceKey,
    saga: frontClearanceSaga,
  });

  const rows = useSelector(selectFilteredFrontClearanceList);
  const loading = useSelector(selectFrontClearanceLoading);
  const meta = useSelector(selectFrontClearanceMeta);

  useEffect(() => {
    dispatch(frontClearanceActions.getFrontClearanceList());
    dispatch(
      frontClearanceActions.getFilterOptions(
        FrontClearanceFilterEnum.Manufacturers,
      ),
    );
    dispatch(
      frontClearanceActions.getFilterOptions(
        FrontClearanceFilterEnum.SuperModels,
      ),
    );
    dispatch(
      frontClearanceActions.getFilterOptions(FrontClearanceFilterEnum.Years),
    );
  }, [dispatch]);

  const hasMoreItems = meta.currentPage < meta.totalPages;

  const getNextPage = () => {
    if (!loading && hasMoreItems) {
      dispatch(frontClearanceActions.getNextPageItems());
    }
  };

  return (
    <Box className={styles.container}>
      <Box className={styles.scrollContent} dir={i18n.dir()}>
        <Box className={styles.pageContent}>
          <BreadCrumb
            title={t("SIDEBAR.FRONT_CLEARANCE")}
            iconPosition="end"
          />
          <ActionBar
            onAddClick={() => dispatch(frontClearanceActions.openAddModal())}
          />
          <Box className={styles.tableContainer}>
            <ScrollableView
              borderless
              height="calc(100vh - 200px)"
              loadMore={getNextPage}
              hasMoreItems={hasMoreItems}
            >
              <FrontCleranceTable rows={rows} loading={loading} />
            </ScrollableView>
          </Box>
        </Box>
      </Box>
      <AddFrontClearanceModal />
    </Box>
  );
};

export default FrontClearance;
